'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarRectangle, iconCalendarRectangleTag } from '@ni/nimble-components/dist/esm/icons/calendar-rectangle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarRectangle };
export { iconCalendarRectangleTag };
export const NimbleIconCalendarRectangle = wrap(IconCalendarRectangle);